import XIconRemoveButton from "components/buttons/XIconRemoveButton";
import CountryDropdown from "components/dropdowns/reactselect/CountryDropdown";
import React from "react";

interface Props {
  value: server.dto.Country[]
  onAdd: (country: server.dto.Country) => void
  onRemove: (country: server.dto.Country) => void
}

const Country = (props: Props) => {
  return <>
    <div className="itemchooserTable">
      {props.value.map(country => (
        <div key={country.key} className="flex gap">
          <XIconRemoveButton group="removeCountry" onClick={() => { props.onRemove(country); }} />
          <div className="grow1">
            {country.name}
          </div>
        </div>
      ))}
    </div>

    <CountryDropdown
      value={null}
      excludeKeys={props.value.map(c => c.key)}
      onChange={props.onAdd}
      config={{
        isSearchable: true,
        placeholder: RESX.GeneralLabels.Search,
        focusOnMount: true
      }}
    />
  </>;
};

export default Country;